import TheNavBar from './TheNavBar.vue'

export { TheNavBar }
export default TheNavBar
